import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';
import { Permission } from 'api/models/response/permissions';

export const loadPermissions = createAsyncThunk<Permission[], number>(
    'permissions/load',
    async (id: number) => {
        const response = await api.permissions.getPermissions(id);
        return response.data;
    }
);
